import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"

import chevronLeftBlack from "images/layout/chevron-left-black.svg?raw"
import chevronLeftWhite from "images/layout/chevron-left-white.svg?raw"
import XIcon from "shared/components/icons/x_icon"

import styles from "./return_button.module.scss"

export default function ReturnButton({ initialStep, color, onClick }) {
  const text = initialStep ? "Cancel" : "Back"
  const icon = color === "white" ? chevronLeftWhite : chevronLeftBlack
  const buttonStyle = classnames("button-tertiary button-outlined", {
    "button-on-color": color === "white",
    "button-with-icon": !initialStep,
  })

  return (
    <div className={styles["button-with-icon"]}>
      <a className={buttonStyle + " " + styles.link} title={text} onClick={onClick}>
        <span className={classnames("button-icon", styles["x-icon"], { [styles.hide]: !initialStep })}>
          <XIcon width="24" height="24" color={color} />
        </span>
        <span className={classnames("button-icon", styles["chevron-icon"], { [styles.hide]: initialStep })}>{parse(icon)}</span>
        <span className={styles.text}>{text}</span>
      </a>
    </div>
  )
}

ReturnButton.propTypes = {
  initialStep: PropTypes.bool,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

ReturnButton.defaultProps = {
  initialStep: false,
  color: "white",
  onClick: () => {},
}
